import {ErrorType} from "./error-type";

export default class ErrorProto {

    public type     : ErrorType

    constructor() {
        this.type = ErrorType.UnknownError
    }

    get message() {
        return "Unknown Error"
    }


}